import {
  KB_AI_PROPOSAL_KIND_LABELS,
  KB_AI_PROPOSAL_SOURCE_LABELS,
  KbAiProposalKind,
  type KbAiProposal,
} from '@gb-ticket/shared-types';
import { Link } from 'react-router';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { KbDiffView } from '@/products/helpdesk/features/kb/kb-diff';

export function KbProposalCard({
  proposal,
  onApply,
  onReject,
  busy,
}: {
  proposal: KbAiProposal;
  onApply: () => void;
  onReject: () => void;
  busy?: boolean;
}) {
  const target =
    proposal.kind === KbAiProposalKind.ARTICLE_EDIT && proposal.article
      ? `/helpdesk/wissen/${proposal.article.slug}`
      : proposal.appliedArticle
        ? `/helpdesk/wissen/${proposal.appliedArticle.slug}`
        : null;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">{proposal.proposedTitle}</CardTitle>
        <CardDescription>
          {KB_AI_PROPOSAL_KIND_LABELS[proposal.kind]} ·{' '}
          {KB_AI_PROPOSAL_SOURCE_LABELS[proposal.source]}
          {proposal.article ? ` · ${proposal.article.title}` : null}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        {proposal.changeSummary ? <p className="text-sm">{proposal.changeSummary}</p> : null}
        <KbDiffView title="Titel" lines={proposal.diff.title} />
        <KbDiffView title="Kurztext" lines={proposal.diff.summary} />
        <KbDiffView title="Inhalt" lines={proposal.diff.body} />
        <div className="flex flex-wrap gap-2">
          {proposal.status === 'PENDING' ? (
            <>
              <Button type="button" size="sm" onClick={onApply} disabled={busy}>
                Übernehmen
              </Button>
              <Button type="button" size="sm" variant="outline" onClick={onReject} disabled={busy}>
                Verwerfen
              </Button>
            </>
          ) : null}
          {target ? (
            <Button asChild size="sm" variant="ghost">
              <Link to={target}>Artikel öffnen</Link>
            </Button>
          ) : null}
        </div>
        <p className="text-xs text-muted-foreground">
          Nichts geht live, bevor Sie übernehmen
          {proposal.kind === KbAiProposalKind.ARTICLE_DRAFT
            ? ' und den Entwurf anschließend veröffentlichen'
            : ''}
          .
        </p>
      </CardContent>
    </Card>
  );
}
